import React, { useState, useContext, useEffect } from "react";
import "./Product_Card.css";
import { Card, CardFooter } from "react-bootstrap";
import SupermarketModal from "../../Common_modal/Supermarket-modal/SupermarketModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faHeart } from "@fortawesome/free-solid-svg-icons";

import { Context } from "../../../utils/context";
import { ShimmerPostItem } from "react-shimmer-effects";
import { useNavigate } from "react-router-dom";
import { AddToCart } from "../../../utils/apis/addToCart/addToCart";

import {
  addWishlist,
  getWishlist,
} from "../../../utils/apis/Wishlist/Wishlist";
function Product_Card({
  product_id,
  price,
  subText,
  text,
  image,
  variant_id,
  m_variant_id,
  product,
  newest,
  schemediscount,
  tradediscount,
  rupeesdiscount,
  rupees,
  percent,
  mrp,
}) {
  const {
    shimmerLoader,
    setShimmerLoader,
    addCartModal,
    setAddCartModal,
    wishlistData,
    wishlistContext,
    triggerCartUpdate,
    setCartCount,
  } = useContext(Context);
  const navigate = useNavigate();
  const { signin } = useContext(Context);
  const handleHeartClick = async (data) => {
    setShimmerLoader(true);
    if (signin) {
      const res = await addWishlist(data);
      if (res?.success) {
        wishlistContext();
      } else {
        alert("Product is no longer available");
      }
      setShimmerLoader(false);
    } else {
      setShimmerLoader(false);
      navigate("/login");
    }
  };

  const handleNavigate = async () => {
    const id = localStorage.setItem("product_id", product_id);

    const token = btoa(product_id.toString());
    navigate(`/vendor-page?product_id=${token}`);
  };


  return (
    <>
      {shimmerLoader ? (
        <ShimmerPostItem card title cta imageHeight={180} />
      ) : (
        <div className="main-product-img-main">
          <Card>
            <div className="main-product-main mx-auto">
              <Card.Img
                onClick={handleNavigate}
                variant="top"
                src={image}
                className="product-img"
                alt="..."
              />
            </div>
            <div className="Coupon-latest-holder">
              {newest == 1 ? (
                <div className="text-holder">
                  <h3>Newest</h3>
                </div>
              ) : (
                ""
              )}
            </div>
            {(percent && percent !== 0) || (rupees && rupees !== 0) ? (
              <div className="Coupon-discount-holder">
                <div className="text-holder pulsate-bck">
                  <div>
                    <p className="offp">Off</p>
                    <h3>{percent ? `${percent} %` : `${rupees} ₹`}</h3>
                  </div>
                </div>
              </div>
            ) : null}

            <div className="add-cart-sec">
              <div
                onClick={async () => {
                  const res = await AddToCart({
                    product_id: product_id,
                    variant_id: variant_id,
                    m_variant_id: m_variant_id,
                  });

                  if (res === true) {
                    await setAddCartModal(true);
                    await triggerCartUpdate();
                    await setCartCount();
                  } else {
                    console.error("Failed to add to cart");
                  }
                }}
              >
                <p>
                  <FontAwesomeIcon
                    icon={faCartShopping}
                    className="cart-logo me-2 "
                  />
                  Cart
                </p>
              </div>

              <div>
                <p
                  onClick={() =>
                    handleHeartClick({
                      product_id: product_id,
                      variant_id: variant_id,
                      m_variant_id: m_variant_id,
                    })
                  }
                >
                  <FontAwesomeIcon
                    icon={faHeart} // Corrected icon usage
                    className={
                      wishlistData?.some(
                        (item) => item.product_id === product_id,
                      )
                        ? "cart-logo me-2 active"
                        : "cart-logo me-2"
                    }
                  />
                  Wishlist
                </p>
              </div>
            </div>
            <Card.Body>
              <Card.Text className=" text-holder  mt-1">
                <h4 onClick={handleNavigate}>{text}</h4>
                <span>{subText}</span>

                <p className="card-second-line">
                  <span className="orgprice">₹{mrp}</span>₹ {price}/-
                </p>
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      )}
    </>
  );
}

export default Product_Card;
